window.luvariReadMore = (element) => {
  let parent = element.parentNode
  parent.classList.add('open')
}
window.luvariReadLess = (element) => {
  let parent = element.parentNode
  parent.classList.remove('open')
}
